import { render, staticRenderFns } from "./AccountRegisteredNamesTable.vue?vue&type=template&id=1870ec14&scoped=true"
import script from "./AccountRegisteredNamesTable.vue?vue&type=script&lang=js"
export * from "./AccountRegisteredNamesTable.vue?vue&type=script&lang=js"
import style0 from "./AccountRegisteredNamesTable.vue?vue&type=style&index=0&id=1870ec14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1870ec14",
  null
  
)

export default component.exports